import { render, staticRenderFns } from "./DictContentEditModal.vue?vue&type=template&id=2e7ffad5"
import script from "./DictContentEditModal.vue?vue&type=script&lang=js"
export * from "./DictContentEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports